/* eslint-env browser */
type Entry = [string, unknown];

function safeJSONParse(value: string | null): unknown {
  try {
    return value ? JSON.parse(value) : null;
  } catch (e) {
    return null;
  }
}

function ensureSessionStorage() {
  return typeof window !== 'undefined';
}

function getParsedEntry([key, value]: [string, string]): Entry {
  return [key, safeJSONParse(value)];
}

export function setInSessionStorage(key: string, value: unknown) {
  return ensureSessionStorage() && sessionStorage.setItem(key, JSON.stringify(value));
}
export function getEntries(): ReadonlyArray<Entry> {
  return ensureSessionStorage() ? Object.entries(sessionStorage).map(getParsedEntry) : [];
}
export function getFromSessionStorage(key: string) {
  return ensureSessionStorage() && key ? safeJSONParse(sessionStorage.getItem(key)) : null;
}
export function clearSessionStorage() {
  return ensureSessionStorage() && sessionStorage.clear();
}
export function removeFromSessionStorage(key: string) {
  return ensureSessionStorage() && key && sessionStorage.removeItem(key);
}
